export default{
    tabelapreco:'',
}